import { MEMBERSHIP_EXTENSION_MODULE } from "@/api_framework/api_config";
import { IMembershipExtensionListingResponse } from "@/api_framework/api_modals/MembershipExtension";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { setMembershipExtensionList } from "@/app_redux/reducers/slices/auth/membership_extension.slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";

AxiosCurlirize(axios, () => {});

export const useMembershipExtensionListingAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (search?: string) => {
      dispatch(
        setLoading({
          key: "isMembershipExtensionListInProgress",
          status: true,
        }),
      );
      const MEMBERSHIP_EXTENSION_LIST_API = search
        ? `${MEMBERSHIP_EXTENSION_MODULE?.MEMBERSHIP_EXTENSION_LISTING_API?.baseURL}?search=${search}`
        : `${MEMBERSHIP_EXTENSION_MODULE?.MEMBERSHIP_EXTENSION_LISTING_API?.baseURL}`;

      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .get(MEMBERSHIP_EXTENSION_LIST_API, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IMembershipExtensionListingResponse>) => {
            if (res.data.status === true) {
              dispatch(setMembershipExtensionList({ data: res?.data?.data }));
            } else {
              dispatch(setMembershipExtensionList({ data: [] }));
            }
            dispatch(
              setLoading({
                key: "isMembershipExtensionListInProgress",
                status: false,
              }),
            );
          })
          .catch((e: AxiosError) => {
            dispatch(
              setLoading({
                key: "isMembershipExtensionListInProgress",
                status: false,
              }),
            );
            dispatch(setMembershipExtensionList({ data: [] }));
            sendCurl(e.config["curlCommand"]);
          });
      } catch (error) {
        dispatch(
          setLoading({
            key: "isMembershipExtensionListInProgress",
            status: false,
          }),
        );
        dispatch(setMembershipExtensionList({ data: [] }));
      }
    },
    [dispatch, configuration],
  );
  return { execute };
};
